module.exports = __webpack_public_path__ + "static/media/nature.6aab0b4e.png";